module.exports = __webpack_public_path__ + "media/images/front/pc/article/thum03-4268712a64ff974dff1d1842c7b22772.png";